import { call, put } from 'redux-saga/effects';
import { get } from 'lodash';
import {
    fetchTemplatesSummaryOfChangesAPI,
    acceptTemplatesSummaryOfChangesAPI,
    sendHandbookReminderAPI,
    fetchLinkedHandbooksByPolicyAPI,
} from 'modules/apis/handbooksTemplates';
import * as handbooksTemplatesActions from '../actions';

/**
 * Saga to fetch a handbook's Summary of Changes
 *
 * @method fetchTemplatesSummaryOfChangesSaga
 * @param  {Object} action The original redux-action
 * @return {Generator}
 */
export function* fetchTemplatesSummaryOfChangesSaga(action) {
    try {
        const {
            payload: { changeId },
        } = action;
        const response = yield call(fetchTemplatesSummaryOfChangesAPI, changeId);
        const data = get(response, 'data');
        yield put(handbooksTemplatesActions.fetchTemplatesSummaryOfChanges.success(data));
        return data;
    } catch (error) {
        yield put(handbooksTemplatesActions.fetchTemplatesSummaryOfChanges.error(error));
        return error;
    }
}

/**
 * Saga to accept a handbook's Policy Summary of Changes
 *
 * @method acceptTemplatesPolicySummaryOfChangesSaga
 * @param  {Object} action The original redux-action
 * @return {Generator}
 * */
export function* acceptTemplatesPolicySummaryOfChangesSaga(action) {
    try {
        const {
            payload: { changeId },
        } = action;
        const response = yield call(acceptTemplatesSummaryOfChangesAPI, changeId);
        const data = get(response, 'data');
        yield put(handbooksTemplatesActions.acceptTemplatesPolicySummaryOfChanges.success(data));
        return data;
    } catch (error) {
        yield put(handbooksTemplatesActions.acceptTemplatesPolicySummaryOfChanges.error(error));
        return error;
    }
}

/**
 * Saga to send handbook reminders to admins
 *
 * @method sendHandbookReminderSaga
 * @param  {Object} action The original redux-action
 * @return {Generator}
 */
export function* sendHandbookReminderSaga(action) {
    try {
        const { payload } = action;
        const response = yield call(sendHandbookReminderAPI, payload);
        const data = get(response, 'data');
        yield put(handbooksTemplatesActions.sendHandbookReminder.success(data));
        return data;
    } catch (error) {
        yield put(handbooksTemplatesActions.sendHandbookReminder.error(error));
        return error;
    }
}

/**
 * Saga to fetch linked handbooks by policy
 *
 * @method fetchLinkedHandbooksByPolicySaga
 * @param  {Object} action The original redux-action
 * @return {Generator}
 */
export function* fetchLinkedHandbooksByPolicySaga(action) {
    try {
        const { payload } = action;
        const response = yield call(fetchLinkedHandbooksByPolicyAPI, payload);
        const data = get(response, 'data');
        yield put(handbooksTemplatesActions.fetchLinkedHandbooksByPolicy.success(data));
        return data;
    } catch (error) {
        yield put(handbooksTemplatesActions.fetchLinkedHandbooksByPolicy.error(error));
        return error;
    }
}
